// extracted by mini-css-extract-plugin
export default {"ranks-modal":"Ranks_ranks-modal__-8VCl","tip":"Ranks_tip__FALk5","ranks":"Ranks_ranks__QT-7R"};